import requests from "@/utils/axios";
import baseApi from "@/api/baseApi";

export default {
    ...baseApi,
    // 模块URL
    modulesUrl: "/attendance/duty/balanceUp",
    levelSelect(query: any) {
        return requests.post(this.modulesUrl + "/levelSelect", query);
    },
    uploadBalance(query: any) {
        return requests.post(this.modulesUrl + "/uploadBalance", query);
    },
};
